import { render } from "./LicenseList.vue?vue&type=template&id=6d56c9dc"
import script from "./LicenseList.vue?vue&type=script&lang=js"
export * from "./LicenseList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__